import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, watch, useContext, useRouter } from "@nuxtjs/composition-api";
import { useMobile } from "~/core/composables/useMobile";
import { ACTIONS as TERMS_AND_CONDITIONS_ACTIONS } from "~/store/affility/user/flows/terms-and-conditions/names";
import { ACTIONS as USER_FEEDBACK_ACTIONS } from "~/store/affility/user/feedback/modals/full-loader/names";
import VueSlickCarousel from 'vue-slick-carousel';
import ApiService from "~/core/services/api-interaction/ApiService";

interface Props {
    popupVisible: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectYourRole',
  props: {
    popupVisible: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { popupVisible: boolean };



const CUSTOMER = 'customer';
const AFFILIATE = 'affiliate';

const affiliate = [
    'Placement in Unilevel',
    'Placement in Binary',
    'CV Points',
    'Binary Commissions based on the rank',
    'Matching bonuses',
    'Leadership Incentives',
    'autoship_incentive',
]

const customer = [
    'NFT Turbo',
    'Purchase Digital Land',
    'Participate in Partnership Deals',
    'Receive minting Rewards',
]

const carouselSetting = {
    centerMode: false,
    centerPadding: "0",
    speed: 500,
    infinite: false,
    slidesToShow: 2,
    touchThreshold: 1,
    arrows: false,
    itemBenefits: null,
    draggable: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ]
};

const isMobile = useMobile();
const context = useContext();
const router = useRouter();

const haveRead = ref(false);
const isSelectRoleLoading = ref(false);
const navigationValue = ref(0);
const roleCarousel = ref(null);

const {
    popupVisible
} = toRefs(props);

const handleAfterChange = ($event) => {
    navigationValue.value = $event;
}

const showAffiliateTOSPopup = () => {
    context.store.dispatch(
        `affility/user/flows/terms-and-conditions/${TERMS_AND_CONDITIONS_ACTIONS.OPEN_AFFILIATE_TERMS_AND_CONDITIONS}`,
        { acceptable: false }
    );
}

const openFullScreenPopup = () => {
    context.store.dispatch(
        `affility/user/feedback/modals/full-loader/${USER_FEEDBACK_ACTIONS.OPEN_FULL_PAGE_LOADING}`,
        context.i18n.t('please_wait')
    );
}

const closeFullScreenPopup = () => {
    context.store.dispatch(`affility/user/feedback/modals/full-loader/${USER_FEEDBACK_ACTIONS.CLOSE_FULL_PAGE_LOADING}`);
}

const handleSelectRole = async (type) => {
    isSelectRoleLoading.value = true;
    openFullScreenPopup();
    try {
        await ApiService.patch(`${context.$config.binaryTreeApi}/api/users`, {
            is_referral_link_active: type === AFFILIATE
        })

        const responseBinary = await ApiService.get(`${context.$config.binaryTreeApi}/api/users`);

        context.store.commit('application/driver/UPDATE_AUTH_USER', {
            isRoleSelected: true,
            isReferralLinkActive: type === AFFILIATE,
            subscriptionExpiresAt: responseBinary?.data?.subscription_expires_at,
            totalOwnPurchaseAmount: responseBinary?.data?.user?.totalOwnPurchaseAmount,
        }, { root: true });

        router.push('/dashboard');
    } catch (e) {
        console.error(e);
    } finally {
        isSelectRoleLoading.value = false;
        closeFullScreenPopup();
    }
}

watch(navigationValue, () => {
    roleCarousel.value?.goTo(navigationValue.value);
});


return { __sfc: true,props, CUSTOMER, AFFILIATE, affiliate, customer, carouselSetting, isMobile, context, router, haveRead, isSelectRoleLoading, navigationValue, roleCarousel, popupVisible, handleAfterChange, showAffiliateTOSPopup, openFullScreenPopup, closeFullScreenPopup, handleSelectRole, VueSlickCarousel }
}

})